@if (selectedOrder) {
  <div class="order-wrapper">
    <h2>Order Information</h2>
    <table class="info-section">
      <tr>
        <td> Order ID: </td>
        <td> {{selectedOrder.inspectorID}} </td>
      </tr>
      <tr>
        <td> SMN: </td>
        <td> {{selectedOrder.SMN}} </td>
      </tr>
      <tr>
        <td> SMN Revision Number: </td>
        <td> {{selectedOrder.revisionNumber}} </td>
      </tr>
      <tr>
        @if (!selectedOrder.justDocuments) {
          <td> PO Number: </td>
        }
        <td> {{getPO(site)}} </td>
      </tr>
      <tr>
        @if (!selectedOrder.justDocuments) {
          <td> Quantity: </td>
        }
        <td> {{selectedOrder.quantity}} </td>
      </tr>
      <tr>
        @if (!selectedOrder.justDocuments) {
          <td> Ship Date: </td>
        }
        <td> {{selectedOrder.shipDate}} </td>
      </tr>
    </table>
    <h2>Contact Information</h2>
    <table class="info-section">
      <tr>
        <td> Contact Name: </td>
        <td> {{selectedOrder.contactName}} </td>
      </tr>
      <tr>
        <td> Contact Email: </td>
        <td> {{selectedOrder.contactEmail}} </td>
      </tr>
      <tr>
        <td> Supplier Name: </td>
        <td> {{selectedOrder.supplierName}} </td>
      </tr>
      <tr>
        <td> Supplier ID: </td>
        <td> {{selectedOrder.supplierID}} </td>
      </tr>
      @if (selectedOrder.comments) {
        <tr>
          <td> Supplier Comments: </td>
          <td> {{selectedOrder.comments}} </td>
        </tr>
      }
    </table>
    <h2> Documents </h2>
    <div class="documents-section">
      @for (docType of documentTypes; track docType) {
        <div class="doctype-section">
          @if (selectedOrder.documents.get(docType).length) {
            <div>
              <h5 class="doctype-section-header">{{docType}}</h5>
              @for (document of selectedOrder.documents.get(docType); track document) {
                <div class="flex-row document-row">
                  <div class="flex-3">
                    <p> {{document.name}} </p>
                  </div>
                  <div class="flex-1">
                    <a class="button document-button button-save" (click)="downloadDocument(document)">
                      Download
                    </a>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    <h2>Inspector Action</h2>
    <table class="inspection-section">
      <tr>
        <td>
          <label for="status" class="label-title">Status:</label>
        </td>
        <td>
          <select [(ngModel)]="selectedOrder.inspectorStatus" name="status" id="status" class="input input-sm" >
            <option value="Pending">Pending</option>
            @if (!selectedOrder.justDocuments) {
              <option value="Uploaded To SAP">Uploaded To SAP</option>
            }
            @if (!selectedOrder.justDocuments) {
              <option value="Resubmission Required">Resubmission Required</option>
            }
            @if (selectedOrder.justDocuments) {
              <option value="Recieved">Recieved</option>
            }
          </select>
        </td>
        <td>
          <label for="comment" class="label-title">Comments:</label>
        </td>
        <td>
          <textarea id="comment" [(ngModel)]="selectedOrder.inspectorComment"></textarea>
        </td>
      </tr>
    </table>
    <mat-dialog-actions>
      <button id="cancel-button" class="button button-cancel" (click)="cancel()"> Cancel </button>
      <span class="gutter"></span>
      <button id="submit-button" class="button button-submit" (click)="submit()"> Submit </button>
    </mat-dialog-actions>
  </div>
}
